import React from 'react';

const Logo = () => {
    return (
        <img src={require('../../../assets/logotype.png')} draggable={false}/>
    );
};

export default Logo;